/* PrintForgeIL — reveal-on-scroll.
   Elements marked [data-reveal] fade and lift in once, when they enter view.
   Everything degrades to "just visible": the opacity drop is applied by CSS
   only under html.pf-js, and that class is set here, so if this file fails
   to load the page still renders fully. */
(function () {
  var root = document.documentElement;

  function showAll() {
    var nodes = document.querySelectorAll('[data-reveal]');
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-in');
  }

  var reduced =
    (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
    root.classList.contains('pfa-noanim');

  if (!('IntersectionObserver' in window) || reduced) {
    showAll();
    return;
  }

  root.classList.add('pf-js');

  function bind() {
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var e = entries[i];
          if (!e.isIntersecting) continue;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    var nodes = document.querySelectorAll('[data-reveal]');
    for (var i = 0; i < nodes.length; i++) {
      var step = parseInt(nodes[i].getAttribute('data-reveal-step') || '0', 10);
      if (step) nodes[i].style.setProperty('--pf-d', Math.min(step, 6) * 70 + 'ms');
      io.observe(nodes[i]);
    }

    window.setTimeout(function () {
      var all = document.querySelectorAll('[data-reveal]:not(.is-in)');
      for (var j = 0; j < all.length; j++) {
        var r = all[j].getBoundingClientRect();
        if (r.top < window.innerHeight) all[j].classList.add('is-in');
      }
    }, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
